"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zonedTimeToUtcOrDefault = void 0;
const date_fns_tz_1 = require("date-fns-tz");
const getAdjustedTimezone_1 = require("./getAdjustedTimezone");
function zonedTimeToUtcOrDefault(date, timezone) {
    const adjustedTimezone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(timezone);
    const utcTime = (0, date_fns_tz_1.zonedTimeToUtc)(date, adjustedTimezone);
    if (!utcTime?.getTime()) {
        console.error(`Timezone "${adjustedTimezone}" not supported. Date: "${date}", UTC: "${utcTime}"`);
        return new Date(date);
    }
    return utcTime;
}
exports.zonedTimeToUtcOrDefault = zonedTimeToUtcOrDefault;
//# sourceMappingURL=zonedTimeToUtcOrDefault.js.map